// extracted by mini-css-extract-plugin
export default {"customer-image":"BlockedCustomerList_customer-image__nFfcY"};